import React from 'react';

const AudioIcon = React.memo(({ width = '24', height = '24' }) => (
  <div className="audio-icon-wrapper svg-icon-wrapper">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="audio-icon svg-icon"
    >
      <path d="M2 10v3" />
      <path d="M6 6v11" />
      <path d="M10 3v18" />
      <path d="M14 8v7" />
      <path d="M18 5v13" />
      <path d="M22 10v3" />
    </svg>
  </div>
));

export default AudioIcon;
